import type { ReactNode } from 'react';
import { FluidMouseLight } from '../../components/ui/fluid-light/fluid-light.js';

interface EditorLayoutProps {
  children: ReactNode;
}

export function EditorLayout({ children }: EditorLayoutProps) {
  return (
    <div
      data-fluid-light-scope="editor-canvas"
      style={{
        width: '100dvw',
        height: '100dvh',
        overflow: 'hidden',
        backgroundColor: 'var(--color-canvas)',
        position: 'relative',
      }}
    >
      <FluidMouseLight />
      {children}
    </div>
  );
}
